import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Button,
} from "@chakra-ui/react";
import React, { useEffect, useState, useContext } from "react";
import { AppContext } from "contexts/AppContext";
import InputField from "views/admin/events/components/InputField";
import FileUpload from "views/admin/events/components/FileUpload";

export default function AddMerchItemDetailModal({
  isOpen,
  onClose,
  createMerch,
}) {
  const [itemName, setItemName] = useState("");
  const [itemPrice, setItemPrice] = useState("");
  const [itemImage, setItemImage] = useState("");
  const [itemNameError, setItemNameError] = useState("");
  const [itemPriceError, setItemPriceError] = useState("");
  const [itemImageError, setItemImageError] = useState("");
  const [uploadError, setUploadError] = useState(null);
  const [fileData, setFileData] = useState(null);

  const { fetchMerchItemData } = useContext(AppContext);

  useEffect(() => {
    setItemName("");
    setItemPrice("");
    setItemImage("");
    setItemNameError("");
    setItemPriceError("");
    setItemImageError("");
    setFileData(null);
  }, [isOpen]);

  const handleFileSelect = (file) => {
    setFileData(file);
    setItemImage(file);
  };

  const handleFileRemove = () => {
    setFileData(null);
    setItemImage("");
  };

  const handleSave = async () => {
    try {
      let isValid = true;

      if (!itemName) {
        setItemNameError("Name is required.");
        isValid = false;
      } else {
        setItemNameError("");
      }

      if (!itemPrice) {
        setItemPriceError("Price is required.");
        isValid = false;
      } else {
        setItemPriceError("");
      }

      if (!itemImage) {
        setItemImageError("Image is required.");
        isValid = false;
      } else {
        setItemImageError("");
      }

      if (!isValid) {
        return;
      }

      createMerch(itemName, itemPrice, fileData);
      fetchMerchItemData();
      onClose();
      setItemNameError("");
      setItemPriceError("");
      setItemImageError("");
      setFileData(null);
    } catch (error) {
      console.error("Error creating merch item:", error);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="xl">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader flex={1} textAlign="center">
          Add Merch Item
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <InputField
            label="Merch Name"
            type="text"
            value={itemName}
            onChange={(e) => setItemName(e.target.value)}
            errorMessage={itemNameError}
            isRequired={true}
          />
          <InputField
            label="Price"
            type="number"
            value={itemPrice}
            onChange={(e) => setItemPrice(e.target.value)}
            errorMessage={itemPriceError}
            isRequired={true}
          />
          <FileUpload
            error={uploadError}
            setError={setUploadError}
            onFileSelect={handleFileSelect}
            onFileRemove={handleFileRemove}
          />
          {itemImageError ? (
            <p style={{ color: "#E53E3E", marginBottom: 16 }}>
              {itemImageError}
            </p>
          ) : null}
          <Button
            fontSize="sm"
            variant="brand"
            fontWeight="500"
            w="100%"
            h="50"
            mb="24px"
            onClick={handleSave}
          >
            Save
          </Button>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
